// src/services/productService.js
import axios from 'axios';
import { API_BASES } from '../config';

const GATEWAY_BASE_URL = API_BASES.gateway; // ✅ usar gateway

export const PRODUCTS_API = axios.create({
  baseURL: `${GATEWAY_BASE_URL}/api/products`,
  headers: {},
});

PRODUCTS_API.interceptors.request.use(config => {
  const globalAuth = axios.defaults.headers.common['Authorization'];
  if (globalAuth) {
    config.headers.Authorization = globalAuth;
  } else {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

PRODUCTS_API.interceptors.response.use(
  res => res,
  err => {
    if (err.response && [401, 403].includes(err.response.status)) {
      err.isAuthError = true;
    }
    return Promise.reject(err);
  }
);

// === Endpoints (sin cambios de lógica) ===
export function createProduct(formData) {
  return PRODUCTS_API.post('', formData, { headers: {}, __skipAuthRedirect: true });
}

export function getMyProducts(page = 0, size = 50) {
  return PRODUCTS_API.get('/my-products', { params: { page, size } });
}

export function listPendingProducts(page = 0, size = 50) {
  return PRODUCTS_API.get('/pending', { params: { page, size } });
}

export function getProductById(id) {
  return PRODUCTS_API.get(`/${id}`);
}

export function decideProduct(id, aprobar, comentario) {
  const params = new URLSearchParams();
  params.append('aprobar', aprobar.toString());
  if (comentario) params.append('comentario', comentario);
  return PRODUCTS_API.put(`/${id}/decision?${params.toString()}`);
}

export function updateProduct(id, data) {
  return PRODUCTS_API.put(`/${id}`, data);
}

export function deleteProduct(id) {
  return PRODUCTS_API.delete(`/${id}`);
}

export function deleteProductFile(id, driveFileId) {
  return PRODUCTS_API.delete(`/${id}/files/${encodeURIComponent(driveFileId)}`);
}

export function getAllProducts(page = 0, size = 50, estado) {
  const params = { page, size };
  if (estado) params.estado = estado;
  return PRODUCTS_API.get('', { params });
}
